export const saLimitedReleaseDetailConstants = {
  SA_LIMITED_RELEASE_DETAIL_LOADING: "SA_LIMITED_RELEASE_DETAIL_LOADING",
  SA_LIMITED_RELEASE_DETAIL_SUCCESS: "SA_LIMITED_RELEASE_DETAIL_SUCCESS",
  SA_LIMITED_RELEASE_DETAIL_FAILURE: "SA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const createSaLimitedReleaseDetailConstants = {
  CREATE_SA_LIMITED_RELEASE_DETAIL_LOADING:
    "CREATE_SA_LIMITED_RELEASE_DETAIL_LOADING",
  CREATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "CREATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS",
  CREATE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
    "CREATE_SA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const editSaLimitedReleaseDetailConstants = {
  EDIT_SA_LIMITED_RELEASE_DETAIL_LOADING:
    "EDIT_SA_LIMITED_RELEASE_DETAIL_LOADING",
  EDIT_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "EDIT_SA_LIMITED_RELEASE_DETAIL_SUCCESS",
  EDIT_SA_LIMITED_RELEASE_DETAIL_FAILURE:
    "EDIT_SA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deleteSaLimitedReleaseDetailConstants = {
  DELETE_SA_LIMITED_RELEASE_DETAIL_LOADING:
    "DELETE_SA_LIMITED_RELEASE_DETAIL_LOADING",
  DELETE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DELETE_SA_LIMITED_RELEASE_DETAIL_SUCCESS",
  DELETE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
    "DELETE_SA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const activateSaLimitedReleaseDetailConstants = {
  ACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING:
    "ACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING",
  ACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS",
  ACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
    "ACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deactivateSaLimitedReleaseDetailConstants = {
  DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING:
    "DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING",
  DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS",
  DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE:
    "DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE",
};
